/** Shared business contact details. */
const CONTACT_PHONE = '37379398167'

/** Build a WhatsApp deep link with a pre-filled message. */
export function buildWhatsappUrl(text: string): string {
  return `https://wa.me/${CONTACT_PHONE}?text=${encodeURIComponent(text)}`
}
